import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { addSessionId } from '@/core/utils/httpHeaders';

export interface SetupWizardSuggestionsRequest {
  brand: string;
  brandDescription: string;
  focus: string;
}

export interface SetupWizardKeywordSuggestion {
  term?: string;
  suggested?: string;
  ambiguous?: boolean;
  senses?: string[];
  rationale?: string;
}

export interface SetupWizardNamedKeywordsGroup {
  name?: string;
  title?: string;
  keywords?: string[] | string;
  terms?: string[] | string;
}

export interface SetupWizardSuggestionsResponse {
  brand?: string;
  universeTitle?: string;
  contextKeywords?: Array<string | SetupWizardKeywordSuggestion>;
  contextSuggestions?: Array<string | SetupWizardKeywordSuggestion>;
  tags?: string[];
  tagSuggestions?: string[];
  groups?: SetupWizardNamedKeywordsGroup[];
  competitors?: SetupWizardNamedKeywordsGroup[];
  themes?: SetupWizardNamedKeywordsGroup[];
}

class SetupWizardService {
  private buildUrl(): string {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();
    return `${gateway}insights-service/${version}/setup-wizard/suggestions`;
  }

  async getSuggestions(payload: SetupWizardSuggestionsRequest): Promise<SetupWizardSuggestionsResponse> {
    const url = this.buildUrl();

    const response = await axios.post<SetupWizardSuggestionsResponse>(url, payload, {
      headers: addSessionId({
        accept: 'application/json',
        'Content-Type': 'application/json',
      }),
      timeout: CONFIG.AUTH.TIMEOUT,
    });

    return response.data;
  }
}

const setupWizardService = new SetupWizardService();
export default setupWizardService;